// src/services/api/admin-user-service.js
import apiKit from "./axios-base";// adjust path if your api service file name is different

const base = "/MtUsers";

const getAccessToken = () => {
  const token = localStorage.getItem("accessToken");
  return token ? `?access_token=${token}` : "";
};

export default {
  // listAdminUsers() {
  //   // Get all users, client-side filter keeps SUB_ADMIN and ADMIN accounts
  //   return apiKit.get(`${base}${getAccessToken()}&filter[limit]=1000`)
  //     .then(res => res.data)
  // },

listAdminUsers() {
  const token = localStorage.getItem("accessToken");

  // Build URL
  let url = `${base}`;
  if (token) {
    url += `?access_token=${token}`;
  }

  // ❌ REMOVE LIMIT – do NOT add filter[limit]
  // nothing else added

  return apiKit.get(url).then(res => {
    return Array.isArray(res.data) ? res.data : (res.data.data || []);
  });
},

  getUserById(id) {
    return apiKit.get(`${base}/${id}${getAccessToken()}`)
      .then(res => res.data);
  },


  createUser(payload) {
    // payload should include username, email, password, contactName, permissions (array), userType (SUB_ADMIN)
    return apiKit.post(`${base}${getAccessToken()}`, payload)
      .then(res => res.data);
  },

  updateUser(id, payload) {
    return apiKit.patch(`${base}/${id}${getAccessToken()}`, payload)
      .then(res => res.data);
  },

  deleteUser(id) {
    return apiKit.delete(`${base}/${id}${getAccessToken()}`)
      .then(res => res.data);
  }
};
